import type { IntlShape, MessageDescriptor } from 'react-intl';
import type { ReleasePlanDay } from 'fym-shared/src/music24/releases';
import { kitVariantName } from '../../../kitLabels';
import { postsMessages } from '../../../posts/postsMessages';
import { studioThemeMessages } from '../../../studio/studioThemeMessages';
import { planMessages } from '../planMessages';
import { planAssetName } from '../rolloutDayCopy';

type PlanAsset = NonNullable<ReleasePlanDay['asset']>;

/**
 * The name of the file of a plan step in the app language: "Story (7 dias antes) v1", "AI reel
 * 15s v2". The API label ("Story (7 days to go) r1") is English, so the Plan tab builds its own
 * from the theme, the variant and the revision (QA 2026-10-28, lit-15 and litr2-3). Null when the
 * answer names no file.
 */
export function planAssetLabel(intl: IntlShape, asset: PlanAsset): string | null {
  if ((asset.label ?? null) === null || asset.kind === 'file') {
    return null;
  }
  let name: string;
  if (asset.kind === 'reel') {
    name = intl.formatMessage(postsMessages.reelLabel, { length: asset.variant });
  } else {
    const theme = (studioThemeMessages as Partial<Record<string, { name: MessageDescriptor }>>)[asset.themeId];
    const base = theme === undefined ? planAssetName(intl, asset.themeId) : intl.formatMessage(theme.name);
    const variant = kitVariantName(intl, asset.variant);
    name = variant === null ? base : `${base} (${variant})`;
  }
  const revision = asset.revision ?? null;
  return revision === null ? name : intl.formatMessage(planMessages.revision, { name, revision });
}
